import * as ActionType from '../../actionTypes/chat';

export const addMessage = (data={}) => ({
    type: ActionType.ADD_MESSAGE,
    payload: {
        id: data.id,
        name: data.name,
        userId: data.userId,
        channelId: data.channelId,
        message: data.message,
        timestamp: data.timestamp
    }
});

export const fetchReactions = (data={}) => ({
    type: ActionType.FETCH_REACTIONS,
    payload: {
        messageIds: data.messageIds
    }
});

export const updateReactions = (data={}) => ({
    type: ActionType.UPDATE_REACTIONS,
    payload: data
});

export const setReaction = (data={}) => ({
    type: ActionType.REGISTER_REACTION,
    payload: {
      entity_id: data.messageId,
      reaction: data.reaction,
      action: 'set'
    }
});

export const unsetReaction = (data={}) => ({
    type: ActionType.REGISTER_REACTION,
    payload: {
      entity_id: data.messageId,
      reaction: data.reaction,
      action: 'unset'
    }
});

export const setUserToState = (data={}) => ({
    type: ActionType.SET_USER_TO_STATE,
    payload: {
      user_id: data.user_id,
      name: data.displayName,
      provider: data.provider,
      isVerified: data.isVerified
    }
});


export const clearUserFromState = () => ({
    type: ActionType.SET_USER_TO_STATE,
    payload: null
});

export const resetState = () => ({
    type: ActionType.RESET_STATE
});

export const setThemeImage = (data={}) => ({
    type: ActionType.SET_THEME_IMAGE,
    payload: {
      theme_image: data.theme_image
    }
})